"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var HtmlToReact = require("html-to-react");
var XSS = /** @class */ (function () {
    function XSS() {
    }
    XSS.validContent = function (data, isDecodingRequired, allowedTags) {
        var decodeFlag = (isDecodingRequired !== undefined ? isDecodingRequired : true);
        var content = (decodeFlag) ? decodeURIComponent(data) : data;
        return (XSS.isClient() ?
            XSS.clientValidContent(content, allowedTags) :
            XSS.serverValidContent(content, allowedTags));
    };
    XSS.serverValidContent = function (content, allowedTags) {
        var INVALID_LABEL_CONTENT = 'INVALID_INVALID_LABEL_CONTENT';
        var isValidNode = function () { return true; };
        var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
        var processingInstructions = [
            {
                processNode: processNodeDefinitions.processDefaultNode,
                shouldProcessNode: function (node) {
                    var isValidTag = true;
                    if (node && node.next && node.next.name) {
                        var allowed_1 = allowedTags[node.next.name.toUpperCase()];
                        if (allowed_1) {
                            var keys = Object.keys(node.next.attribs);
                            if (Array.prototype.slice.call(keys).find(function (attribute) {
                                return allowed_1.indexOf(attribute) < 0;
                            })) {
                                isValidTag = false; // found dis-allowed attribute
                            }
                        }
                        else {
                            isValidTag = false;
                        }
                    }
                    return isValidTag;
                },
            },
            {
                processNode: function () { return INVALID_LABEL_CONTENT + content; },
                shouldProcessNode: function (node) {
                    return true;
                },
            },
        ];
        var htmlToReactParser = new HtmlToReact.Parser();
        var reactComp = htmlToReactParser.parseWithInstructions(content, isValidNode, processingInstructions);
        if ((typeof reactComp === 'string' && reactComp.startsWith(INVALID_LABEL_CONTENT)) ||
            (typeof reactComp === 'object' && reactComp[0] && reactComp[0].startsWith(INVALID_LABEL_CONTENT))) {
            return 'INVALID';
        }
        else {
            return content;
        }
    };
    XSS.isClient = function () {
        return (typeof window !== 'undefined' && window.document && window.document.createElement) ? true : false;
    };
    XSS.clientValidContent = function (content, allowedTags) {
        var temp = document.createElement('div');
        temp.innerHTML = content;
        return this.isApprovedContent(Array.prototype.slice.call(temp.querySelectorAll('*')), allowedTags)
            ? content : 'INVALID';
    };
    XSS.isApprovedContent = function (elements, allowedTags) {
        // search for dis-allowed tags
        return elements.find(function (element) {
            var allowed = allowedTags[element.tagName];
            if (allowed) {
                if (Array.prototype.slice.call(element.attributes).find(function (attribute) { return allowed.indexOf(attribute.name) < 0; })) {
                    allowed = undefined; // found dis-allowed attribute
                }
            }
            return !allowed; // return true if dis-allowed element found
        }) === undefined;
    };
    return XSS;
}());
exports.default = XSS;
//# sourceMappingURL=XSS.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/utils/XSS.js
// module id = 1039
// module chunks = 8